export enum AutodocType {
	HelpText = 1,
	Description = 2,
	Definition = 3
}

export const AUTODOC_TYPE_LABELS = {
	[ AutodocType.HelpText ]: 'Help Text',
	[ AutodocType.Definition ]: 'Definition',
	[ AutodocType.Description ]: 'Description'
};

/**
 * Bitwise flags for AI text generation operations.
 * Multiple fields can be combined using bitwise OR.
 * Examples: Definition=1, Description=2, Both=3, All=7
 */
export enum AutodocTypeFlag {
	None = 0,
	Definition = 1,
	Description = 2,
	HelpText = 4
}

export interface BulkActionObjects {
	autodocDefinition: Array<number> | null;
	autodocDescription: Array<number> | null;
	autodocHelpText: Array<number> | null;
}
